module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('UserNotificationsManager', {

		configure: function (options) {
			/*
				newVideo
				newPhotoset
				startLiveshow
				newPost
			*/
			this.registerOptions('', {
				autoRender: false,
				'embed.container': '#user-notitfications',
				template: 'user_notifications_manager',
				widgets: {
					getSettingsApi: {
						widget: 'Api',
						method: 'notification.getSettings'
					},
					setSettingsApi: {
						widget: 'Api',
						method: 'notification.setSettings'
					}
				},

				handleDom: {
					change: {
						target: 'input[type="checkbox"]',
						event: 'change',
						callback: '_setSettings'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.getSettings().then(function(params) {
				var pm = this.rwom1('@root #permissionManager');
				var data = params.params.answer.response;
				/*var data = {
					publishVideoEmail: 1,
					publishPhotosetEmail: 0,
					startLiveshowEmail: 0,
					publishBlogPostEmail: 0
				};*/

				fox.each(data, function(value, key) {
					if (value === 1) {
						return;
					}

					data[key] = 0;
				});

				if (!fox.isEmpty(pm.getMemberInfo('emailVerified'))) {
					data.emailVefied = true;
				}

				this.setTemplateOptions(data);
				this.render();
			}.bind(this))
			.catch(console.error);
			
			this.callParent('running', arguments);
		},

		getSettings: function() {
			return this.wom1('#getSettingsApi').psend({});
		},

		_setSettings: function() {
			var elms = this.dom('input[type="checkbox"]');
			var data = {};

			fox.each(elms, function(input) {
				data[input.name] = Number(input.checked);
			});

			this.setSettings(data);
		},

		setSettings: function(data) {

			this.wom1('#setSettingsApi').psend({events: data})
				.then(function() {
					this.dispatchEvent('saved');
				}.bind(this))
				.catch(function(err) {
					console.error(err);
				});
		}

	}, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-notifications-settings/widget/notificationsManager.js
// module id = 545
// module chunks = 4